import { render, staticRenderFns } from "./QrcodeView.vue?vue&type=template&id=0990a208&scoped=true"
import script from "./QrcodeView.vue?vue&type=script&lang=js"
export * from "./QrcodeView.vue?vue&type=script&lang=js"
import style0 from "./QrcodeView.vue?vue&type=style&index=0&id=0990a208&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0990a208",
  null
  
)

export default component.exports